export class UserModel {
  Id: number;
  UserName: string;
  FamilyName?: any;
  GivenName?: any;
  UPN?: any;
  IsActive: boolean;
  CreatedDate: Date;
  FullName?: string;
  FullNameWithEmail?: string;
  IsPrivacyPolicyAgreed: boolean;
  IsGDS: boolean;
  ISOCode: string;
}


